export const getIdsString = (list: { id: number }[]) =>
  list.map((item) => item.id).join(",");
